<template>
  <div class="app_dialog" :class="{ dimmed, fixed }">
    <div class="dialog_content" :style="contentStyle">
      <span v-if="dialogData.iconClass" class="icon" :class="dialogData.iconClass"/>
      <p class="title" :class="dialogData.titleClass" v-if="dialogData.title" v-html="dialogData.title"></p>
      <p class="description" v-if="dialogData.description" v-html="dialogData.description"></p>

      <p class="action">
        <template v-if="dialogData.type === 'confirm'">
          <ui-button @click="onCloseClick(noValue)">{{ cancel }}</ui-button>
          <ui-button primary2 @click="onCloseClick(yesValue)">{{ yes }}</ui-button>
        </template>
        <template v-else-if="dialogData.type === 'alert'">
          <ui-button @click="onCloseClick">{{ ok }}</ui-button>
        </template>
      </p>
    </div>
  </div>
</template>

<script>
import getDialogData from '@/data/dialog-data'
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'AppDialog',
  components: {
    UiButton
  },
  props: {
    dialogType: {
      type: String,
      required: false
    },
    customData: {
      type: Object,
      required: false
    },
    yes: {
      type: String,
      default () {
        return this.$t('common.confirm')
      }
    },
    no: {
      type: String,
      default () {
        return this.$t('common.no')
      }
    },
    ok: {
      type: String,
      default () {
        return this.$t('common.ok')
      }
    },
    cancel: {
      type: String,
      default () {
        return this.$t('common.cancel')
      }
    },
    yesValue: {
      default: true
    },
    noValue: {
      default: false
    },
    dimmed: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: true
    },
    contentStyle: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      rawData: null
    }
  },
  computed: {
    dialogData () {
      if (this.customData) {
        return this.customData
      }

      const paths = this.dialogType.split('.')
      let data = this.rawData

      for (const path of paths) {
        if (!data[path]) {
          throw new Error(`invalid dialogType: ${this.dialogType}`)
        } else {
          data = data[path]
        }
      }
      return data
    }
  },
  created () {
    this.rawData = getDialogData(this.$i18n)

    if (document.activeElement) {
      document.activeElement.blur()
    }
  },
  methods: {
    onCloseClick (value) {
      if (this.$close) {
        // called by vue-modal-dialogs
        this.$close(value)
      } else {
        // called by normal component
        this.$emit('onCloseClick', value)
      }
    }
  }
}
</script>

<style lang="scss">
.app_dialog {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;

  &.fixed {
    position: fixed;
  }

  &.dimmed {
    pointer-events: auto;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .dialog_content {
    pointer-events: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 430px;
    box-sizing: border-box;
    padding: 50px 40px 37px 40px;
    border-radius: 14px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    text-align: center;

    .icon {
      margin-bottom: 13px;
    }

    .title {
      font-size: 20px;
      font-weight: bold;
      color: #444;
      margin-bottom: 10px;
      line-height: 1.2;

      &.warning {
        color: $brandColor;
      }
    }

    .description {
      font-size: 14px;
      color: #2f2f2f;
      margin-bottom: 28px;
      line-height: 1.43;
      white-space: pre-line;
      word-break: break-all;
    }

    .action {
      button {
        margin: 0 3px;
      }
    }
  }
}
</style>
